import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type VariationPropertyFragment = { id: number, pk: number, valueName: string, attributeName: string };

export const VariationPropertyFragmentDoc = gql`
    fragment VariationPropertyFragment on VariationPropertyType {
  id
  pk
  valueName
  attributeName
}
    `;